'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellular1Bar = function DeviceSignalCellular1Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
    _react2.default.createElement('path', { d: 'M12 12L2 22h10z' })
  );
};
DeviceSignalCellular1Bar = (0, _pure2.default)(DeviceSignalCellular1Bar);
DeviceSignalCellular1Bar.displayName = 'DeviceSignalCellular1Bar';

exports.default = DeviceSignalCellular1Bar;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/device/signal-cellular-1-bar.js
 ** module id = 1386
 ** module chunks = 0
 **/